import script from "./EditEvent.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditEvent.vue?vue&type=script&setup=true&lang=ts"

import "./EditEvent.vue?vue&type=style&index=0&id=54bad6a5&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54bad6a5"]])

export default __exports__